import ConfigManager from '@config/ConfigManager'
import CorinAuth from '@src/services/Auth/CorinAuth'
import MSKAuth from '@src/services/Auth/MSKAuth'

const Auth = ConfigManager.config.preLogin ? CorinAuth : MSKAuth

export default Auth
